const weekens = [
  "星期日",
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
];

export function getWeek(dateTime) {
  const date = new Date(dateTime);
  const day = date.getDay();
  return weekens[day];
}                                                                                     

export function getDate(dateTime) {
  const date = new Date(dateTime);
  const theDate = date.getDate();
  return theDate < 10 ? '0' + theDate : theDate;
}

export function getDateTime() {
  const date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  month = month < 10 ? '0' + month : month;
  let day = date.getDate();
  day = day < 10 ? '0' + day : day;
  let hour = date.getHours();
  hour = hour < 10 ? '0' + hour : hour;
  let minute = date.getMinutes();
  minute = minute < 10 ? '0' + minute : minute; 
  let second = date.getSeconds();
  second = second < 10 ? '0' + second : second;
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}  

export function secondsToString(diff) {
  let seconds = Math.floor(diff % 60);
  let minutes = Math.floor((diff / 60) % 60);
  let hours = Math.floor((diff / (60 * 60)) % 24);
  let secondsString = `
					${hours < 10 ? "0" : ""}${hours}:
					${minutes < 10 ? "0" : ""}${minutes}:
					${seconds < 10 ? "0" : ""}${seconds}`;
  return secondsString;
}

